import React, { useEffect, useState } from 'react';
import { GraduationCap } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { API } from './joinConfig';

export const CampusLeaderboard = () => {
  const { t } = useLanguage();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    fetch(`${API}/campus-leaderboard`).then(r => r.json()).then(setRows).catch(() => {});
  }, []);
  const max = rows[0]?.count || 1;
  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6" data-testid="campus-leaderboard">
      <div className="mb-5 flex items-center gap-2">
        <GraduationCap className="h-5 w-5 text-party-green" />
        <h3 className="font-join text-xl font-bold text-gray-900">{t({ en: 'Campus Battle', bn: 'ক্যাম্পাস লড়াই' })}</h3>
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="campus-leaderboard-empty">{t({ en: 'No campus on the board yet. Put yours first!', bn: 'এখনো কোনো ক্যাম্পাস নেই। আপনারটি প্রথমে আনুন!' })}</p>
      ) : (
        <ol className="space-y-3">
          {rows.map((r, i) => (
            <li key={r.name} data-testid={`campus-row-${i}`}>
              <div className="mb-1 flex items-center justify-between text-sm">
                <span className="truncate pr-2 font-semibold text-gray-900"><span className="font-join mr-2 text-gray-500">{i + 1}</span>{r.name}</span>
                <span className="font-join font-bold text-party-green">{r.count}</span>
              </div>
              <div className="h-1.5 overflow-hidden rounded-full bg-gray-100">
                <div className="h-full rounded-full bg-gradient-to-r from-party-green to-[#FFD60A] transition-[width] duration-700" style={{ width: `${(r.count / max) * 100}%` }} />
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
